import React, { Component } from "react";

// Material-UI
import {
  Paper,
  Dialog,
  FlatButton,
  FloatingActionButton,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui";

import Loading from "../Loading";
import TemplateEditor from "./TemplateEditor";

export default class TemplateView extends Component {
  getStyles() {
    return {
      center: {
        textAlign: "center",
      },
      paper: {
        width: "96%",
        margin: 30,
      },
      floatingButton: {
        marginLeft: 25,
      },
    };
  }

  componentWillMount() {
    this.props.authFetchDetails(
      "templates/" + this.props.params._id,
      this.props.token.jwt,
    );
  }

  render() {
    let { details } = this.props;
    let { center, paper, floatingButton } = this.getStyles();
    let title = this.props.params._id ? `Edit ${details.name}` : "New Template";

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <div>
          <TemplateEditor title={title} template={details} />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/document_templates/TemplateView.js